import { render, staticRenderFns } from "./client_wdmr_data_record.vue?vue&type=template&id=ad49775c&"
import script from "./client_wdmr_data_record.vue?vue&type=script&lang=js&"
export * from "./client_wdmr_data_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports